import { TeamOutlined, DownloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { consultationHistory } from 'containers/App/selectors';
import { FC, useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { HeaderTitle, SearchConsultation, Pagination } from 'components';
import { listMedicalSearchRequest, t_cpap_instructions } from 'types';
import TableConsultation from './TableConsultation';
import { Wrapper } from './styles';
import { getCpapInstructItems, getListMedicalFromCPAP, getCsvListMedicalFromCPAP } from './thunk';

const ConsultationHistory: FC = () => {
  const dispatch = useDispatch();
  const { items, totalItems, check, searchValue } = useSelector(consultationHistory);
  const [page, setPage] = useState<number>(1);
  const [valueSearch, setValueSearch] = useState<listMedicalSearchRequest>(searchValue);

  useEffect(() => {
    dispatch(getCpapInstructItems({ pageNumber: page }));
  }, []);

  const changePage = useCallback(
    (pageNumber: number) => {
      dispatch(getListMedicalFromCPAP({ pageNumber: pageNumber, perPage: 20, searchValue: valueSearch }));
      setPage(pageNumber);
    },
    [dispatch, valueSearch],
  );

  const onSearch = useCallback(
    async (values: listMedicalSearchRequest) => {
      if (values) {
        setValueSearch(values);
        await dispatch(getListMedicalFromCPAP({ pageNumber: 1, perPage: 20, searchValue: values }));
      }
      setPage(1);
    },
    [dispatch, page],
  );

  const generateCSV = async () => {
    const result: any = await dispatch(
      getCsvListMedicalFromCPAP({
        pageNumber: 1,
        perPage: 0,
        searchValue: valueSearch,
      }),
    );

    const listCsv =
      result.payload.items.length > 0
        ? result.payload.items.map((item: t_cpap_instructions, index: number) => ({
            no: index + 1,
            facility_name: item?.facility_name,
            patient_id: item?.patient_id,
            patient_name: item?.patient_name,
            period_of_no_visit_medical: `${item?.period_of_no_visit_medical}ヶ月`,
            comment: '',
          }))
        : [];
    const csvString = [
      ['NO', '医療機関名', 'ID', 'ご利用者名', '未受診期間', '備考'],
      ...listCsv.map((item: any) => Object.values(item)),
    ]
      .map((e) => e.join(','))
      .join('\n');
    const bom = '\uFEFF';
    const file = new Blob([bom, csvString], { type: 'application/octet-stream' });
    saveAs(file, 'outputCSV.csv');
  };

  return (
    <Wrapper>
      <HeaderTitle title="未受診状況確認" icon={TeamOutlined}></HeaderTitle>
      <SearchConsultation onSearch={onSearch} />
      <div className="list-patient">
        <span className="extraLargeFont">患者一覧</span>
        <div className="wrap-export-button">
          <p className="smallBoldFont">検索した条件で</p>
          <Button disabled={check} onClick={() => generateCSV()} className="btn-output">
            <DownloadOutlined /> CSV出力
          </Button>
        </div>
      </div>
      <div className="section">
        <Pagination totalItems={totalItems} page={page} onChangePage={changePage} />
        <div className="table">
          <TableConsultation data={items} />
        </div>
      </div>
    </Wrapper>
  );
};

export default ConsultationHistory;
